import { createContext, useContext } from 'react';

import { CreateFormBuilderStoreType } from './create-builder-store';

export type PredefinedOptionsLists = Array<{
  value: string;
  label: string;
  options: Array<{ value: string; label: string }>;
  isHidden: boolean;
}>;
export type FormBuilderContextType =
  | {
      store: CreateFormBuilderStoreType;
      predefinedOptionsLists: PredefinedOptionsLists;
    }
  | undefined;

const FormBuilderContext = createContext<FormBuilderContextType>(undefined);

export const useFormBuilderContext = () => {
  const context = useContext(FormBuilderContext);
  if (!context) throw new Error('Missing FormBuilderContext');

  return context;
};

export const FormBuilderContextProvider = FormBuilderContext.Provider;
